<template>
    <div
        :data-type="context.type"
        :class="`formulate-input-element formulate-input-element--${context.classification}`"
    >
        <BootstrapPhoneNumberInput
            ref="phoneNumberInput"
            :phone-data="localValue"
            :countries="localCountries"
            :preferred-country-code="localPreferredCountryCode"
            @update="handleNumberUpdated"
            @validation="handleValidationEvent"
            @remove="handleRemove"
            :edit-mode="localEditMode"
            :noRemove="noRemove"
          ></BootstrapPhoneNumberInput>
    </div>
</template>

<script>
import BootstrapPhoneNumberInput from '@/components/shared/BootstrapPhoneNumberInput.vue';

export default {
    name: 'FormulateFullPhoneNumber',
    components: {
        BootstrapPhoneNumberInput
    },
    mixins: [],
    props: {
        context: {
            // the required Formulate context prop
            type: Object,
            required: true,
        },
        countries: {  // structure should be { code, name } for each country
            type: Array,
            default: () => [],
        },
        // just the code, if there is a preferred one 
        preferredCountryCode: {
            type: String,
            default: '',
        },
        noRemove: {
            type: Boolean,
            default: false,  // if true, don't show/allow the remove button
        },
    },
    data() {
        return {
            localValue: {
                // this is the local value for the phone number, used for v-model binding - match fields in BootstrapPhoneNumberInput
                name: '',
                number: '',
                country: '',
                extension: '',
            }
        }
    },
    computed: {
        localDisabled() {
            return this.context.attributes?.disabled ?? this.context.disabled ?? false;
        },
        localEditMode() {
            return !this.localDisabled;  // add more conditions later if needed
        },
        localCountries() {
            // return the countries prop or an empty array if not provided - have a default list?
            return this.countries || [];
        },
        localPreferredCountryCode() {
            // get from somewhere else if not provided in props?
            return this.preferredCountryCode || '';
        },
    },
    watch: {
        'context.model': {
            handler(newVal) {
                // since context.model is an object, oldVal and newVal will always be same...
                // handle changes to the model value in formulate form, set our localValue
                // will also get called when we set the model value... so need to diff things

                console.log('in FormulateFullPhoneNumber - model changed: ', newVal);
                if (!newVal) {
                    // if newVal is null or undefined, we clear the localValue
                    this.localValue = {
                        name: '',
                        number: '',
                        country: '',
                        extension: '',
                    };
                } else {
                    // otherwise, we set the localValue from the newVal
                    this.localValue = {
                        name: newVal.name || '',
                        number: newVal.number || '',
                        country: newVal.country || '',
                        extension: newVal.extension || '',
                    };
                }
            },
            immediate: true,  // this seems to not match what other components do... so no need?
        },
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        handleNumberUpdated(numberData, numberIsValid) {
            // this is called when the phone number input emits an update event
            // we update the localValue
            // and we set context.model to the numberData if it's valid
            // or null if not valid (so form can watch for required validation)
            this.localValue = numberData;
            if (numberIsValid) {
                // this.$set(this.context.model, this.context.name, numberData);  // maybe this is good?
                this.context.model = this.localValue;
            } else {
                this.context.model = null;
            }
        },
        handleValidationEvent(numberIsValid) {
            // this is called on ANY updates in the phone number input, whether valid or not
            // we can use this to update the validation state in the context???
            // but maybe not needed?  just use update event?
            // this.context.validation = numberIsValid;  // if we want to set validation state ??? not sure if this works....
            console.log('handleValidationEvent in FormulateFullPhoneNumber', numberIsValid);
        },
        handleRemove() {
            this.context.model = null;  // clear the model when removing
        },
    },
}
</script>

<style lang="scss" scoped>
</style>